import HomeBotoxList from "./pages/HomeBotoxList.vue";
import BotoxConfigurazioneDiagnosiListPage from "./pages/BotoxConfigurazioneDiagnosiListPage.vue";

export default {
    HomeBotoxList,
    BotoxConfigurazioneDiagnosiListPage,
};
